export const STAGES = {
  INITIAL: 'initial',
  EDIT: 'edit',
  SUCCESS: 'success',
  IN_PROGRESS: 'in_progress',
  ERROR: 'error',
  ERROR_SERVER: 'error_server',
  CLERK: 'clerk',
}
